import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MUIButton, ButtonList } from 'app/components/Form';
import FontIcon from 'app/components/FontIcon/FontIcon.jsx';
import { Permission } from 'app/containers/Permissions/index.js';
import classes from './NotificationsRightPanel.module.scss';
import history from 'app/main/routerHistory';
import Loader from 'app/components/Loader/Loader.jsx';
import { colors } from 'app/styles/colors';
import Notification from 'app/containers/Notifications/Notification/Notification';
import { useDispatch, useSelector } from 'react-redux';
import { notificationsSelector } from 'app/store/selectors/notifications';
import { updateNotification } from 'app/store/reducers/notifications';
export const maxNotifsToDisplay = 1000;
const NotificationsRightpanel = (props) => {
    const { title = 'Notifications', noNotificationsLabel = 'No notifications ts', onCloseNotifications, isLoading, } = props;
    const dispatch = useDispatch();
    const notifications = useSelector(notificationsSelector);
    const onShowAll = () => {
        onCloseNotifications();
        history.push('/notifications/all');
    };
    const onManageSubscriptions = () => {
        onCloseNotifications();
        history.push('/notifications/manage');
    };
    const onClickNotif = (notification) => {
        onCloseNotifications();
        if (notification.unread) {
            const _notif = Object.assign(Object.assign({}, notification), { unread: false });
            dispatch(updateNotification(_notif));
        }
    };
    const renderNotifs = () => {
        if (!notifications)
            return null;
        const endIndex = notifications.length < maxNotifsToDisplay ? notifications.length : maxNotifsToDisplay;
        const arrayFromEndIndex = Array.from({ length: endIndex }, (v, i) => i);
        const notifsToReturn = arrayFromEndIndex.map((el, i) => {
            const notif = notifications[i];
            return (_jsx("div", { children: _jsx(Notification, { notification: notif, isLastNotif: i === endIndex - 1, onClickNotif: onClickNotif }) }, notif.id));
        });
        return notifsToReturn;
    };
    return (_jsxs("div", { className: classes.container, "data-testid": "notifications-righPanel", children: [_jsxs("div", { className: classes.title, children: [_jsx(FontIcon, { icon: "fas-bell", className: classes.notificationsIcon, style: { color: colors.grey, fontSize: 18 } }), _jsx("div", { className: classes.titleString, children: title }), _jsxs(ButtonList, { children: [_jsx(MUIButton, { onClick: onShowAll, children: "Show all" }), _jsx(Permission, { actions: ['notifications___read'], children: _jsx(MUIButton, { onClick: onManageSubscriptions, children: "Manage subscriptions" }) })] })] }), _jsx("div", { style: { height: 'calc(100% - 36px)', maxHeight: 'calc(100% - 36px)', overflowY: 'auto' }, children: _jsx("div", { className: classes.notifications, children: isLoading ? _jsx(Loader, {}) : notifications && notifications.length ? renderNotifs() : noNotificationsLabel }) })] }));
};
export default NotificationsRightpanel;
